import React, { useState } from "react";
import {
	MDBBtn,
	MDBIcon,
	MDBInput,
	MDBSpinner,
	MDBTextArea,
} from "mdb-react-ui-kit";

import style from "./style.module.scss";
import ImageContainer from "../ImageContainer";
import { createStructuredSelector } from "reselect";
import { selectWallet } from "../../Containers/Client/selector";
import { connect, useDispatch } from "react-redux";
import { addNft } from "../../Containers/PostContainer/action";
import { toast } from "react-toastify";
import { payNftFee } from "../../Utils/blockchainHelper";
import { copyToClipboard } from "../../Utils/textHelper";
import ActiveText from "../ActiveText";
import { getImageUrl, handleUploadFile } from "../../Utils/uploadHelper";
import ProfilePicture from "../ProfilePicture";

function FormNft({ wallet, profilePicture }, key) {
	const [uploaded, setIsUploaded] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [receipt, setReceipt] = useState(null);
	const [image, setImage] = useState(null);

	const dispatch = useDispatch();
	const initialState = {
		title: "",
		description: "",
		price: process.env.REACT_APP_NFT_FEE,
		owner: {
			wallet,
		},
		image: null,
		filename: null,
	};
	const [formData, setFormData] = useState(initialState);
	const { title, description } = formData;

	const onInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const formNotNull = (to) => {
		if (to === "clear") return !!(formData.description || formData.title);
		return !!(formData.description && formData.title && image);
	};

	const cbFailedCreateNFT = (error) => {
		toast.error(error);
		setIsUploaded(false);
		setIsLoading(false);
	};

	const cbSuccessCreateNFT = (token, contractAddress, hashReceipt) => {
		toast.success("NFT successfully created!");
		setReceipt({ hashReceipt, token, contractAddress });
		setIsUploaded(true);
		setIsLoading(false);
	};

	const cbSuccessPay = () => {
		formData.filename = image.name;
		formData.image = image.base64;
		dispatch(addNft(formData, cbSuccessCreateNFT, cbFailedCreateNFT));
	};

	const onClickSubmit = async () => {
		if (!wallet) {
			toast.error(
				"You're not connected to any wallet! Please setup your wallet at profile settings!"
			);
			return null;
		}
		setIsLoading(true);
		await payNftFee(wallet, cbSuccessPay, () => {
			setIsLoading(false);
		});
	};

	const onUploadFile = async (e) => {
		const newFile = await handleUploadFile(e);
		setImage(newFile[0]);
	};
	const onClickReload = () => {
		setFormData(initialState);
		setIsUploaded(false);
		setReceipt(null);
		setImage(null);
	};
	return (
		<div className={style.container}>
			<div className={style.containerContent}>
				{image ? (
					<div className={style.imageContainer}>
						<ImageContainer
							url={getImageUrl(image.base64)}
							name={image.name}
							isPostForm={!uploaded ? true : ""}
							action={!uploaded ? () => setImage(null) : ""}
							key={key}
							deleteOption={isLoading ? false : true}
						/>
					</div>
				) : (
					""
				)}
				{uploaded ? (
					<div className={style.notify}>
						Successfully uploaded!
						<div>
							You can check your NFT on:{" "}
							<ActiveText isScanTx={true} text={receipt.hashReceipt} />
						</div>
						<div>
							Contract address:{" "}
							<div
								className={style.copyClipboard}
								onClick={() => copyToClipboard(receipt.contractAddress)}
							>
								{receipt.contractAddress}
							</div>
						</div>
						<div>
							With tokenId:{" "}
							<div
								className={style.copyClipboard}
								onClick={() => copyToClipboard(receipt.token)}
							>
								{receipt.token}
							</div>
						</div>
					</div>
				) : (
					""
				)}
			</div>
			<MDBInput
				className={style.inputField}
				label='NFT Title'
				name='title'
				id='title'
				value={title}
				onChange={onInputChange}
				disabled={uploaded ? true : isLoading ? true : false}
			/>
			<MDBTextArea
				className={style.inputField}
				rows={2}
				label='NFT Description'
				value={description}
				name='description'
				id='description'
				disabled={uploaded ? true : isLoading ? true : false}
				onChange={onInputChange}
			></MDBTextArea>
			{!image ? (
				<div className={style.cameraContainer}>
					<input
						type='file'
						accept='image/*'
						multiple
						style={{ display: "none" }}
						id='contained-button-file-nft'
						onChange={onUploadFile}
						className={style.inputField}
					/>
					<label
						htmlFor='contained-button-file-nft'
						className={style.cameraIcon}
					>
						<MDBIcon fas icon='camera' />
					</label>
				</div>
			) : (
				""
			)}
			<div className={style.btnContainer}>
				<div className='me-3'>
					<ProfilePicture isPost={true} url={profilePicture} />
				</div>
				{formNotNull("clear") && !uploaded ? (
					<MDBBtn
						type='button'
						className='btn btn-danger me-2'
						onClick={() => setFormData(initialState)}
						disabled={isLoading ? true : false}
					>
						Clear
					</MDBBtn>
				) : (
					""
				)}
				<MDBBtn
					type='button'
					disabled={formNotNull("upload") ? (isLoading ? true : false) : true}
					className='btn'
					style={{ backgroundColor: "#ffa500" }}
					onClick={uploaded ? onClickReload : onClickSubmit}
				>
					{isLoading && (
						<MDBSpinner size='sm' role='status' tag='span' className='me-2' />
					)}
					{uploaded ? "Create More NFT" : "Create NFT"}
				</MDBBtn>
			</div>
		</div>
	);
}
const mapStateToProps = createStructuredSelector({
	wallet: selectWallet,
});
export default connect(mapStateToProps)(FormNft);
